import type { Theme } from '@bingo/shared';

const KEY = 'bingo.theme';
const media = () => window.matchMedia('(prefers-color-scheme: dark)');

export function applyTheme(theme: Theme) {
  const dark = theme === 'dark' || (theme === 'system' && media().matches);
  document.documentElement.dataset.theme = dark ? 'dark' : 'light';
  try {
    localStorage.setItem(KEY, theme);
  } catch {
    /* private mode: the account still remembers the choice */
  }
}

/** Keeps "system" in sync when the phone or computer switches between day and night mode. */
export function watchSystemTheme(getTheme: () => Theme) {
  const m = media();
  const onChange = () => getTheme() === 'system' && applyTheme('system');
  m.addEventListener('change', onChange);
  return () => m.removeEventListener('change', onChange);
}
